var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup44(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(441 1473) rotate(180)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 19,
    cy: 19,
    r: 19,
    transform: "translate(403 1435)",
    fill: "#11989a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-right",
    "data-name": "Icon awesome-arrow-right",
    d: "M7.653,3.822l.892-.892a.96.96,0,0,1,1.362,0l7.81,7.806a.96.96,0,0,1,0,1.362l-7.81,7.81a.96.96,0,0,1-1.362,0l-.892-.892a.965.965,0,0,1,.016-1.378l4.841-4.612H.964A.962.962,0,0,1,0,12.062V10.776a.962.962,0,0,1,.964-.964H12.51L7.669,5.2A.958.958,0,0,1,7.653,3.822Z",
    transform: "translate(413 1442.353)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup44);
export default __webpack_public_path__ + "static/media/Group 44.96fda2fbbd63d501447dbf692a4f4231.svg";
export { ForwardRef as ReactComponent };